import { useToast } from "@packsize/toast";
import { packsizeHooks } from "@packsize/utils";
import { useCallback } from "react";
import { useIntl } from "react-intl";

export const useCopyToClipboard = () => {
	const intl = useIntl();
	const { toastSuccess, toastError } = useToast();

	const toastCopySuccess = useCallback(() => {
		toastSuccess({ message: intl.formatMessage({ id: "Copied to clipboard", defaultMessage: "Copied to clipboard" }) });
	}, [intl, toastSuccess]);

	const toastCopyError = useCallback(() => {
		toastError({
			message: intl.formatMessage({ id: "Failed to copy to clipboard", defaultMessage: "Failed to copy to clipboard" }),
		});
	}, [intl, toastError]);

	return packsizeHooks.useCopyToClipboard(toastCopySuccess, toastCopyError);
};
